module.exports = __webpack_public_path__ + "img/success.ef0827e4.webp";